// extracted by mini-css-extract-plugin
export default {"swanCtaMainText":"TryonText_swanCtaMainText__ThLBw","swanCtaMainText__bgText":"TryonText_swanCtaMainText__bgText__fqAo3"};